"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Program = void 0;
var constants_1 = require("../../constants");
var helpers_1 = require("../../helpers/");
var DEFAULT_IMAGE = 'https://kijk.nl/static/images/default_editoriallandscape.png';
function getSvgNicamIconsList(ratings) {
    var svgList = [];
    var parsedRatingSvg = (0, helpers_1.getSvgFromRating)((ratings === null || ratings === void 0 ? void 0 : ratings.rating) || '', false);
    if (parsedRatingSvg) {
        svgList.push(parsedRatingSvg.documentElement);
    }
    var subRatingIcons = ratings === null || ratings === void 0 ? void 0 : ratings.subRatings;
    subRatingIcons === null || subRatingIcons === void 0 ? void 0 : subRatingIcons.map(function (sub) {
        var parsedSubratingsSvg = (0, helpers_1.getSvgFromRating)(sub, true);
        parsedSubratingsSvg ? svgList.push(parsedSubratingsSvg.documentElement) : null;
    });
    return svgList;
}
var filterEmptyDrmFields = function (drm) {
    if (!drm)
        return null;
    return Object.keys(drm).reduce(function (acc, key) {
        var _a;
        if (drm[key] === null)
            return acc;
        return __assign(__assign({}, acc), (_a = {}, _a[key] = drm[key], _a));
    }, {});
};
var Program = (function () {
    function Program(data) {
        var _a, _b, _c, _d;
        this.guid = '';
        this.fwassetid = '';
        this.title = '';
        this.secondaryTitle = '';
        this.description = '';
        this.image = '';
        this.seriesTitle = '';
        this.duration = 0;
        this.sources = [];
        this.tracks = [];
        this.metadata = {};
        this.svgNicamIconsList = [];
        this.tvSeasonId = '';
        this.isLive = false;
        this.kijkLink = '';
        this.kijkEpisodeLink = '';
        if (!data) {
            return;
        }
        this.guid = data.guid;
        this.availableRegion = data.availableRegion || '';
        this.fwassetid = data.guid;
        this.type = data.type;
        this.description = data.description || '';
        var imageUrl = (_b = (_a = data.imageMedia) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.url;
        this.image = "".concat(constants_1.CLOUDINARY_BASE_URL, "ar_16:9,c_fill,h_540,w_auto/").concat(imageUrl || DEFAULT_IMAGE);
        this.seriesTitle = ((_c = data.series) === null || _c === void 0 ? void 0 : _c.title) || '';
        this.duration = data.duration;
        if (data.sources) {
            this.sources = data.sources.map(function (_a) {
                var drm = _a.drm, sources = __rest(_a, ["drm"]);
                return (__assign(__assign({}, sources), { drm: filterEmptyDrmFields(drm) }));
            });
        }
        this.tracks = data.tracks;
        this.metadata = data.metadata || {};
        var media = (data.media || [])[0];
        this.isAvailable = (media === null || media === void 0 ? void 0 : media.availabilityState) || false;
        if (media === null || media === void 0 ? void 0 : media.availableDate) {
            this.availableDate = new Date(+media.availableDate);
        }
        if ((media === null || media === void 0 ? void 0 : media.type) === 'LIVE') {
            this.isLive = true;
            this.metadata.c_media_playbacktype = 'live';
            this.metadata.media_duration = 0;
            this.metadata.c_media_live = true;
            this.metadata.media_videotype = 'live';
        }
        this.svgNicamIconsList = ((_d = data.ratings) === null || _d === void 0 ? void 0 : _d[0]) ? getSvgNicamIconsList(data.ratings[0]) : [];
        this.tvSeasonId = data.tvSeasonId;
        this.seasonNumber = data.seasonNumber;
        this.tvSeasonEpisodeNumber = data.tvSeasonEpisodeNumber;
    }
    return Program;
}());
exports.Program = Program;
